var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introTitle"},[_c('div',{staticClass:"title"},[_c('img',{attrs:{"src":require("../../../../assets/img/renyiOverview/jiantou.png")}}),_c('span',{staticClass:"titlecont"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"heng"})])
}
var staticRenderFns = []

export { render, staticRenderFns }